module.exports = __webpack_public_path__ + "img/goldair_cargo_blue.7e5f363e.png";